import api from '../NetworkService';

const SESSION_BASE_URL = '/api/user-profile/me';

export const mapUserProfileToSelectedObject = ({
    entity_type: entityType,
    selected_client: selectedClient,
    selected_account: selectedAccount,
}) => {
    const selected = {
        all: entityType === 'all',
        client: entityType === 'client',
        account: entityType === 'account',
    };

    return ({
        client_selected: {
            ...selectedClient,
            id: selected.all ? 'all' : selectedClient.id,
            name: selected.all ? 'All Accounts' : selectedClient.name,
            selected: selected.all || selected.client,
        },
        account_selected: {
            ...selectedAccount,
            selected: selected.account,
        },
    });
};

const mapSelectedObjectToUserProfile = data => (
    data.client_selected === 'all'
        ? ({
            selected_client_id: null,
            selected_account_id: null,
        }) : ({
            selected_client_id: data.client_selected || null,
            selected_account_id: data.account_selected || null,
        })
);

// @TODO: Refactor this usage to use state on redux
export const getSelectedObjects = () => api
    .getClient()
    .get(SESSION_BASE_URL)
    .then(response => mapUserProfileToSelectedObject(response.data));

export const setSelectedAccount = data => api
    .getClient()
    .patch('/api/user-profile/me', mapSelectedObjectToUserProfile(data))
    .then(response => response.data);
